import ApiClient from '@afosto/api/ApiClient';

class Emails {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * Add a new email
   *
   * @param {Object} body - Mail object
   * @param {Object} options - The additional request options
   * @description Adds a email
   * @returns {Promise}
   */
  createMail(body, options = {}) {
    return this.apiClient.request({
      url: `/mes/emails`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Delete email
   *
   * @param {string} id - Id that belongs to the email
   * @param {Object} options - The additional request options
   * @description Delete an email
   * @returns {Promise}
   */
  deleteMail(id, options = {}) {
    return this.apiClient.request({
      url: `/mes/emails/${id}`,
      method: 'delete',
      ...options,
    });
  }

  /**
   * Get the list of emails
   *
   * @param {string} folder
   * @param {string} inbox
   * @param {Object} query - The optional path parameters
   * @param {string} [query.addressee]
   * @param {Object} options - The additional request options
   * @description Returns a list of emails
   * @returns {Promise}
   */
  listEmails(inbox, folder, query = {}, options = {}) {
    const params = {
      addressee: query.addressee,
      folder,
      inbox,
    };

    return this.apiClient.request({
      url: `/mes/emails`,
      method: 'get',
      params,
      ...options,
    });
  }

  /**
   * Get an email and mark it
   *
   * @param {string} id - Id that belongs to the email
   * @param {Object} query - The optional path parameters
   * @param {string} [query.markAs] - Mark the email
   * @param {Object} options - The additional request options
   * @description Mark as read and return email
   * @returns {Promise}
   */
  markAsRead(id, query = {}, options = {}) {
    const params = {
      mark_as: query.markAs,
    };

    return this.apiClient.request({
      url: `/mes/emails/${id}`,
      method: 'get',
      params,
      ...options,
    });
  }

  /**
   * Adds a new email (unauthenticated)
   * 
   * @param {Object} body - Mail object 
   * @param {Object} options - The additional request options
   * @description Adds a new email, unauthenticated endpoint, spam protection using recaptcha
  
   * @returns {Promise}
   */
  submitForms(body, options = {}) {
    return this.apiClient.request({
      url: `/mes/emails/form`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Update an email
   *
   * @param {string} id - Id that belongs to the email
   * @param {Object} body - Mail object
   * @param {Object} options - The additional request options
   * @description Update an existing email
   * @returns {Promise}
   */
  updateEmail(id, body, options = {}) {
    return this.apiClient.request({
      url: `/mes/emails/${id}`,
      method: 'put',
      data: body,
      ...options,
    });
  }
}

export const emails = new Emails();

export default Emails;
